import axios from "axios"

const state = {
    user_name: null,
    user_letter: null,
    user_login: null,
    user_email: null,
    user_phone: null,
    user_prefix: null,
    user_country: null,
    user_type: null,
    user_photo: null,
    visitorId: null,
    telegram: null,
    verified: false,
    subscribed: false,
    isTgApp: false,
    isPWA: false,
    ref: null,
    groups: [],
    bot_username: 'pw_origin_bot'
}

const getters = {
    isAuthenticated: (state)        => !!state.user_name,
    StateUserName: (state)          => state.user_name,
    StateLetter: (state)            => state.user_letter,
    StateUserLogin: (state)         => state.user_login,
    StateUserEmail: (state)         => state.user_email,
    StateUserPhone: (state)         => state.user_phone,
    StateUserPrefix: (state)        => state.user_prefix,
    StateUserCountry: (state)       => state.user_country,
    StateUserAccess: (state)        => state.user_type,
    StateUserPhoto: (state)         => state.user_photo,
    StateUserVisitorId: (state)     => state.visitorId,
    StateTelegramUsername: (state)  => state.telegram,
    StateUserSubscribed: (state)    => state.subscribed,
    StateVerified: (state)          => state.verified,
    StateTgApp: (state)             => state.isTgApp,
    StatePWA: (state)               => state.isPWA,
    StateUserRef: (state)           => state.ref,
    StateGroups: (state)            => state.groups,
    StateBotUsername: (state)       => state.bot_username,
}

const actions = {
    // пошаговая регистрация
    async ActionRegStep({ commit }, user) {
        const user_reg = await axios.post("/api/public/reg_step/", { 
            email: user.email,
            phone: user.phone,
            prefix: user.prefix,
            country: user.country,
            ref: (user.ref) ? user.ref : null,
            utm: (user.utm) ? user.utm : {},
        }).then(res => {
            return res.data
        })

        if (user_reg.result && user_reg.data) {
            try {
                await commit("setUser", user_reg.data)
            } catch { }

            const email = (user_reg.data.login) ? user_reg.data.login : null
            const firstName = 'Аноним'
            const lastName = 'Анонимович'
            const phone = (user_reg.data.phone) ? '+'+user_reg.data.prefix.toString() + user_reg.data.phone.toString() : null
            const user_id = (user_reg.data.id) ? user_reg.data.id : null
            const visitorId = (user_reg.data.visitorId) ? user_reg.data.visitorId : null

            // перезапуск скрипта чата с новым visitorId
            try {
                window.BrevoConversationsSetup = {
                    startHidden: false,
                    language: 'ru',
                    colors: {
                        buttonText: '#5e7e4a', 
                        buttonBg: '#aeee83'
                    },
                    buttonSize: 50,
                    visitorId: visitorId
                }
                BrevoConversations('restart')
                BrevoConversations('updateIntegrationData', {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    phone: phone,
                    notes: user_id
                })
            } catch(e) {
                console.log('error', e)
            }
            return user_reg
        } else {
            return { result: false, errors: user_reg.errors }
        }
    },
    // заполнение данных
    async ActionRegFill({ commit }, user) {
        const user_fill = await axios.post("/api/user/fill/", { name: user.name, password: user.password }).then(res => {
            return res.data
        })
        if (user_fill.result && user_fill.data) {
            try {
                await commit("setUser", user_fill.data)
            } catch { }
            
            try {
                const name_arr = user_fill.data.name.split(' ')
                const firstName = (name_arr[0]) ? name_arr[0] : 'Аноним'
                const lastName = (name_arr[1]) ? name_arr[1] : 'Анонимович'

                BrevoConversations('restart')
                BrevoConversations('updateIntegrationData', {
                    firstName: firstName,
                    lastName: lastName,
                })
            } catch { }
            return { result: true, data: user_fill.data }
        } else {
            return { result: false, errors: user_fill.errors }
        }
        
    },
    // обновление данных
    async ActionUpdUser({ commit }, user) {
        const user_upd = await axios.post("/api/user/upd/", user).then(res => {
            return res.data
        })
        if (user_upd.result && user_upd.data) {
            try {
                await commit("setUser", user_upd.data)
            } catch { }

            try {
                const name_arr = user_upd.data.name.split(' ')
                const email = (user_upd.data.login) ? user_upd.data.login : null
                const firstName = (name_arr[0]) ? name_arr[0] : 'Аноним'
                const lastName = (name_arr[1]) ? name_arr[1] : 'Анонимович'
                const phone = (user_upd.data.phone) ? '+'+user_upd.data.prefix.toString() + user_upd.data.phone.toString() : null

                BrevoConversations('restart')
                BrevoConversations('updateIntegrationData', {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    phone: phone
                })
            } catch { }
            return { result: true, data: user_upd.data }
        } else {
            return { result: false, errors: user_upd.errors }
        }
    },
    // логин
   async ActionLogin({ commit, rootState }, user) {
        let user_result = await axios.post("/api/public/login/", { username: user.login, password: user.password }).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            try {
                await commit("setUser", user_result.data)
            } catch { }

            // перезапуск скрипта чата с новым visitorId
            try {
                const name_arr = user_result.data.name.split(' ')
                const email = (user_result.data.login) ? user_result.data.login : null
                const firstName = (name_arr[0]) ? name_arr[0] : 'Аноним'
                const lastName = (name_arr[1]) ? name_arr[1] : 'Анонимович'
                const phone = (user_result.data.phone) ? '+'+user_result.data.prefix.toString() + user_result.data.phone.toString() : null
                const user_id = (user_result.data.id) ? user_result.data.id : null
                const visitorId = (user_result.data.visitorId) ? user_result.data.visitorId : null
                const isPwaOrTgApp = (rootState && rootState.auth && (rootState.auth.isTgApp || rootState.auth.isPWA)) ? true : false

                // если приложение, то скрываем 
                window.BrevoConversationsSetup = {
                    startHidden: (isPwaOrTgApp) ? true : false,
                    language: 'ru',
                    colors: {
                        buttonText: '#5e7e4a', 
                        buttonBg: '#aeee83'
                    },
                    buttonSize: 50,
                    visitorId: visitorId
                }
                BrevoConversations('restart')
                BrevoConversations('updateIntegrationData', {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    phone: phone,
                    notes: user_id
                })
            } catch { }

            //TODO: перезапуск данных socket
            // console.log('socket', this)

            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },
    // логин WEBAPP телеграм
    async ActionWebAppTgLogin({ commit, rootState }, obj) {
        let result_query
        if (obj.ref) result_query = obj.user + '&ref=' + obj.ref
        else result_query = obj.user
        let user_result = await axios.post("/api/public/login_webapp/", result_query).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            try {
                await commit("setUser", user_result.data)
            } catch { }

            // перезапуск скрипта чата с новым visitorId только если не приложение телеграм 
            if(!rootState.auth.isTgApp) {
                try {
                    const name_arr = user_result.data.name.split(' ')
                    const email = (user_result.data.login) ? user_result.data.login : null
                    const firstName = (name_arr[0]) ? name_arr[0] : 'Аноним'
                    const lastName = (name_arr[1]) ? name_arr[1] : 'Анонимович'
                    const phone = (user_result.data.phone) ? '+'+user_result.data.prefix.toString() + user_result.data.phone.toString() : null
                    const user_id = (user_result.data.id) ? user_result.data.id : null
                    const visitorId = (user_result.data.visitorId) ? user_result.data.visitorId : null
                    const isPwaOrTgApp = (rootState && rootState.auth && (rootState.auth.isTgApp || rootState.auth.isPWA)) ? true : false

                    window.BrevoConversationsSetup = {
                        startHidden: (isPwaOrTgApp) ? true : false,
                        language: 'ru',
                        colors: {
                            buttonText: '#5e7e4a', 
                            buttonBg: '#aeee83'
                        },
                        buttonSize: 50,
                        visitorId: visitorId
                    }
                    BrevoConversations('restart')
                    BrevoConversations('updateIntegrationData', {
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        phone: phone,
                        notes: user_id
                    })
                } catch { }
            }

            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },

    // логин телеграм
    async ActionTgLogin({ commit, rootState }, user) {
        let user_result = await axios.post("/api/public/login_tg/", user).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            try {
                await commit("setUser", user_result.data)
            } catch { }

            // перезапуск скрипта чата с новым visitorId только если не приложение телеграм 
            if(!rootState.auth.isTgApp) {
                try {
                    const name_arr = user_result.data.name.split(' ')
                    const email = (user_result.data.login) ? user_result.data.login : null
                    const firstName = (name_arr[0]) ? name_arr[0] : 'Аноним'
                    const lastName = (name_arr[1]) ? name_arr[1] : 'Анонимович'
                    const phone = (user_result.data.phone) ? '+'+user_result.data.prefix.toString() + user_result.data.phone.toString() : null
                    const user_id = (user_result.data.id) ? user_result.data.id : null
                    const visitorId = (user_result.data.visitorId) ? user_result.data.visitorId : null
                    const isPwaOrTgApp = (rootState && rootState.auth && (rootState.auth.isTgApp || rootState.auth.isPWA)) ? true : false

                    window.BrevoConversationsSetup = {
                        startHidden: (isPwaOrTgApp) ? true : false,
                        language: 'ru',
                        colors: {
                            buttonText: '#5e7e4a', 
                            buttonBg: '#aeee83'
                        },
                        buttonSize: 50,
                        visitorId: visitorId
                    }
                    BrevoConversations('restart')
                    BrevoConversations('updateIntegrationData', {
                        email: email,
                        firstName: firstName,
                        lastName: lastName,
                        phone: phone,
                        notes: user_id
                    })
                } catch { }
            }

            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },
    // привязка телеграм
    async ActionTgBind({ commit }, user) {
        let user_result = await axios.post("/api/public/bind_tg/", user).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            try {
                await commit("setUser", user_result.data)
            } catch { }
            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },
    // отвязка телеграм
    async ActionTgUnbind({ commit }, user) {
        let user_result = await axios.post("/api/public/unbind_tg/", user).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            // отвязка аватара
            try {
                await commit("setUser", user_result.data)
            } catch { }
            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },
    // логаут
    async LogOut({ commit }) {
        const logout_result = await axios.get("/api/public/logout/").then(res => {
            return res.data
        })
        if (logout_result.result) {
            await commit("logout")
            await commit("resetWalletState")
            await commit("resetTransfer")
            await commit("resetRecipients")
        }
        return { result: true }
    },
    // получение данных пользователя
    async ActionGetUser({ commit }) {
        const get = await axios.get("/api/user/get_user/").then(res => {
            return res.data
        })
        if (get.result && get.data) {
            try {
                await commit("setUser", get.data)
            } catch { }
            return { result: true, data: get.data }
        } else {
            return { result: false, errors: get.errors }
        }
    },
    // Привязка чатбота / подписка на уведомления
    async ActionSubscribeBot({ commit }, user) {
        let user_result = await axios.get("/api/user/subscribe_bot/", user).then(res => {
            return res.data
        })
        if (user_result.result && user_result.data) {
            try {
                await commit("setUser", user_result.data)
            } catch { }
            return { result: true, data: user_result.data }
        } else {
            return { result: false, errors: user_result.errors }
        }
    },
    async setVisitorId ({ commit }, visitorId) {
        try {
            await commit("setVisitorId", visitorId)
        } catch { }
        return true
    },
    async setTgApp ({ commit }, isTgApp) {
        try {
            await commit("setTgApp", isTgApp)
        } catch { }
        return true
    },
    async setPWA ({ commit }, isPWA) {
        try {
            await commit("setPWA", isPWA)
        } catch { }
        return true
    },
    async setBotUsername ({ commit }, bot_username) {
        try {
            await commit("setBotUsername", bot_username)
        } catch { }
        return true
    },
    async setAddGroup ({ commit }, group) {
        try {
            await commit("setAddGroup", group)
        } catch { }
        return true
    }
}

const mutations = {
    setUser(state, user) {
        state.user_name = (user.name) ? user.name : user.login
        state.user_login = (user.login) ? user.login : null
        state.user_email = (user.email) ? user.email : null
        state.user_phone = (user.phone) ? user.phone : null
        state.user_prefix = (user.prefix) ? user.prefix : null
        state.user_country = (user.country) ? user.country : null
        state.user_letter = (user.name && user.name[0]) ? user.name[0] : null
        state.user_type = (user.type) ? user.type : null
        state.user_photo = (user.photo) ? user.photo : null
        state.visitorId = (user.visitorId) ? user.visitorId : null
        state.telegram = (user.telegram) ? user.telegram : null
        state.verified = (user.verified) ? user.verified : false
        state.ref = (user.ref) ? user.ref : false
        state.groups = (user.groups) ? user.groups : []
        state.subscribed = (user.subscribed) ? user.subscribed : false
    },

    setPhoto(state, user) {
        state.user_photo = user.photo_url
    },
    
    setVisitorId(state, visitorId) {
        state.visitorId = visitorId
    },

    setTgApp(state, isTgApp) {
        state.isTgApp = isTgApp
    },

    setPWA(state, isPWA) {
        state.isPWA = isPWA
    },

    logout(state) {
        state.user_name = null
        state.user_login = null
        state.user_letter = null
        state.user_email = null
        state.user_phone = null
        state.user_prefix = null
        state.user_country = null
        state.user_type = null
        state.user_photo = null
        state.visitorId = null
        state.telegram = null
        state.verified = false
        state.subscribed = false
        state.ref = null
        state.groups = []
    },

    setBotUsername(state, bot_username) {
        state.bot_username = bot_username
    },

    setAddGroup(state, group) {
        let arr = state.groups
        arr.push(group)
        arr = [...new Set(arr)]
        state.groups = arr
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}